const regExpSpace = /&nbsp;/gi;
const regExpAmpersand = /&amp;/gi;
const regExpGreaterThan = /&gt;/gi;
const regExpSmallerThan = /&lt;/gi;

/**
 * Replaces special entities with better user facing euivalents
 *
 * @param  {string} string
 * @return {string}
 */
export const replaceSpecialEntities = (string) =>
    string
        .replace(regExpSpace, ' ')
        .replace(regExpGreaterThan, '>')
        .replace(regExpSmallerThan, '<')
        .replace(regExpAmpersand, '&');

/**
 * Removes all the markup and returns a string with plain text.
 *
 * @param  {String} markup
 * @return {String} - plain text or empty string
 */
export const filterMarkup = (markup) => {
    const isString = typeof markup === 'string';
    return isString ? replaceSpecialEntities(markup.replace(/<[^>]+>/g, '')) : '';
};
